import { Injectable } from '@angular/core';

/** Service com métodos utilitários das campanhas */
@Injectable({
    providedIn: 'root'
})
export class CampanhaUtilsService {

    /** Cria a sugestão do nome da campanha com base no seu pacote e cliente */
    createNomeCampanha(nomePacoteCampanha: string, nomeCliente: string): string {
        let nome = '';
        // Nome do pacote
        if (nomePacoteCampanha) {
            nome += nomePacoteCampanha.trim();
        }

        if (nome != '') {
            nome += ' ';
        }

        // Nome do cliente
        if (nomeCliente) {
            nome += nomeCliente.trim();
        }

        return nome;
    }
}
